import { SCENE_INTERACTION } from "../../../constants/scene";
import { tourID } from "../../../socket/SocketTour";
import { tourExists } from "../../../socket/socketHelper";
import { SCENE_EVENTS } from "../../MVC/Model";
import { ICON } from "../../Icons/Icons";
import { SOCKET_EVENTS } from "../../../socket/Events";
import gsap from "gsap";

class TourItem {
  constructor({ model, container, tour, onJoin }) {
    this.model = model;
    this.container = container;
    this.tour = tour;
    this.onJoin = onJoin;
    this.init();
  }

  init() {
    const oneToOne = this.model.isOneToOneTour(this.tour);
    const isPrivateTour = this.tour.isPrivateTour || oneToOne;
    const iAmInvited = !oneToOne && this.tour.invitedUsers?.includes(this.model.socket.getUserData().socketId);
    let disabled = '';
    if (oneToOne || (!iAmInvited && isPrivateTour)) {
      disabled = 'disabled';
    };
    const row = $(`
      <div class="tour-item">
        <div class="tour-item__info">
          <h3 class="tour-item__name">${this.tour.name}</h3>
          <span class="tour-item__stats">${this.getStats()} Active Participants</span>
        </div>
        ${disabled ? `<button data-id="${this.tour.id}" class="tour-item__button">${ICON.LOCK} Private</button>` : `<button data-id="${this.tour.id}" class="tour-item__button" >Join</button>`}
      </div>
    `);

    row.on("click", ".tour-item__button", (e) => {
      this.onJoin && this.onJoin();
      const tourId = $(e.target).attr('data-id');
      const tourStarted = tourExists(tourId, this.model.tourData);
      const tour = tourStarted[tourId];
      const iAmInvited = tour?.invitedUsers?.includes(this.model.socket.getUserData().socketId);
      if (tour && this.model.isOneToOneTour(tour)) {
        this.model.confirm($trans('one-to-one-tour-closed'), () => {
          this.model.onSocketEventUpdateUI();
        }, {
          header: true,
          title: $trans('private-tour-text'),
          confirmBtnTxt: $trans('ok-text'),
          xBtn: true,
          cancelBtn: false,
          dimmerClose: false,
        }, () => {
          this.model.onSocketEventUpdateUI();
        })
        return;
      }
      if (tour && tour.isPrivateTour && !iAmInvited) {
        this.model.confirm($trans('you-must-be-invited-to-join-private-tour'), () => {
          this.model.onSocketEventUpdateUI();
        }, {
          header: true,
          title: $trans('private-tour-text'),
          confirmBtnTxt: $trans('ok-text'),
          xBtn: true,
          cancelBtn: false,
          dimmerClose: false,
        }, () => {
          this.model.onSocketEventUpdateUI();
        })
        return;
      }
      const guide = this.model.socket.getUserBySocketId(tourStarted[tourId].owner);
      if (guide) {
        if (
          this.model.socket.getUserData().currentSceneId !==
          guide.currentSceneId
        ) {
          this.model.nextSceneId = guide.currentSceneId;
          this.model.dispatchEvent({
            type: SCENE_INTERACTION.JUMP_TO_SCENE,
            data: {
              sceneId: guide.currentSceneId,
            },
          });
        }
        this.model.onTourStarted(tourId);
        this.model.socket.enableGuidedCamera();
        this.model.socket.acceptGuideMode(tourStarted[tourId]);
      } else {
        this.model.onTourEnded();
      }
    });
    this.container.append(row);
  }

  getStats() {
    return this.tour.users?.length || 0;
  }
}

const tourList = `
<div class="tour-modal" id="list-tour-modal">
  <div class="tour-modal-content">
    <header>
        <h1>
          ${ICON.GLOBE}
          <span>Join an active tour</span>
        </h1>
        <span class="material-icons md-24 clickable close-modal" id="close-share-location">close</span>
    </header>
    <div class="tour-modal-description">Take part in any tour on this list</div>
    <section id="list-tour-items"></section>
  </div>
</div>
`;

const tourIcon = `
  <div class="tour-banner__icon">
      ${ICON.TOUR}
      <span class="tour-banner__count">0</span>
      <span class="tour-banner__count-measure" aria-hidden="true"></span>
  </div>
`;

const tourInfo = `
<div class="tour-banner_info">
  <div class="tour-banner__icon__content_2" style="position: absolute; z-index: 1;">
    <span class="tour-banner__count__text" data-lang="guided-tours">Guided tours</span>
  </div>
  <div class="tour-banner__icon__content_3" style="position: absolute; z-index: 2;">
    <span class="tour-banner__count__text_up" data-lang="click-to-join">Click to join</span>
  </div>
</div>`;

const wrapper = `
<div class="tour-banner">
  <div class="tour-banner__content">
    ${tourIcon}
    ${tourList}
    ${tourInfo}
  </div>
</div>
`;

export default class TourBanner {
  constructor({ model }) {
    this.model = model;
    this.tourBanner = $(wrapper);
    this.tourModal = this.tourBanner.find(".tour-modal");
    this.tourIconBtn = this.tourBanner.find(".tour-banner__icon");
    this.closeModal = this.tourBanner.find(".close-modal");
    this.listContainer = this.tourBanner.find("#list-tour-items");
    this._tl = null;
    this._hasShown = false;
    this._tourCount = 0;
    this._countCycling = false;
    this._countShowsSentence = false;
    this._countTween = null;
    this._countDelay = null;
    this._countPassesLeft = 0;
    this._countCyclePlayed = false;

    $(document.body).append(this.tourBanner);
    this.hide();

    this.initModal();
    this.initListeners();
  }

  initListeners() {
    const hideEvents = [
      SCENE_EVENTS.GUIDED_MODE_STOP,
      SCENE_EVENTS.TOUR_MODE_WINDOW_OPENED,
      SCENE_EVENTS.GUIDE_MODE_OFF,
    ];
    hideEvents.forEach((event) => {
      this.model.addEventListener(event, () => {
        this.hide();
      });
    });

    this.model.addEventListener(SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA, () => {
      this.handleTourIcon();
    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_STARTED, () => {
      this.show();
    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_ENDED, () => {
      this.handleTourIcon();
    });
    this.model.addEventListener(SCENE_EVENTS.GUIDED_MODE_START, () => {
      this.handleTourIcon();
    });
    this.model.socket.addEventListener(SOCKET_EVENTS.INIT_USERS, () => {
      this.handleTourIcon();
    });
  }

  initModal() {
    this.tourIconBtn.on("click", (e) => {
      e.stopPropagation()
      this.updateTourItems();
      this.showTourModal()
    });

    this.closeModal.on("click", () => {
      this.hideTourModal();
    });
    this.tourModal.on('click', (e) => {
      e.stopPropagation();
    })
    $(document).on('click', () => {
      this.hideTourModal();
    })

    this.updateTourItems();
  }

  show() {
    this.tourBanner.show();
    this.hideTourModal();
    this.updateIconCount();
    this.startCountCycle();

    // Only animate on first show
    if (!this._hasShown) {
      this._hasShown = true;

      // Don't animate if tour-banner_info is gone
      if (!this.tourBanner.find('.tour-banner_info').length) {
        return;
      }

      if (this._tl) {
        this._tl.kill();
        this._tl = null;
      }

      const c2 = this.tourBanner.find('.tour-banner__icon__content_2');
      const c3 = this.tourBanner.find('.tour-banner__icon__content_3');

      gsap.set([c2, c3], { autoAlpha: 0 });

      const fadeBlock = (el, hold) => {
        this._tl
          .to(el, { autoAlpha: 1, duration: 0.3 })
          .to({}, { duration: hold })
          .to(el, { autoAlpha: 0, duration: 0.3 });
      };

      this._tl = gsap.timeline({ repeat: 20, defaults: { ease: "power1.out" } });
      this._tl.to({}, { duration: 3 }); // 3 second delay before starting
      fadeBlock(c2, 1);
      fadeBlock(c3, 1);
      this._tl.to({}, { duration: 3 }); // 3 second delay before repeating
    }
  }

  hide() {
    this.tourBanner.hide();
    this.stopCountCycle();
    if (this._tl) {
      this._tl.kill();
      this._tl = null;
    }
    const elems = this.tourBanner.find('.tour-banner__icon__content_2, .tour-banner__icon__content_3');
    gsap.killTweensOf(elems);
    gsap.set(elems, { autoAlpha: 0 });
  }

  showTourModal() {
    this.tourModal.addClass("is-active");
    // Kill animation and remove tour info forever when user clicks tour icon
    if (this._tl) {
      this._tl.kill();
      this._tl = null;
    }
    this.tourBanner.find('.tour-banner_info').remove();
  }

  hideTourModal() {
    this.tourModal.removeClass("is-active");
  }

  countSentence(count) {
    const fallback = `Guided Tours running (${count})`;
    return typeof $trans === 'function'
      ? $trans('guided-tours-running', { count }, fallback)
      : fallback;
  }

  measureCountWidth(text) {
    const measure = this.tourBanner.find('.tour-banner__count-measure');
    measure.text(text);
    return Math.ceil(measure.get(0).getBoundingClientRect().width);
  }

  renderCountLabel(sentence) {
    const el = this.tourBanner.find('.tour-banner__count');
    const count = this._tourCount ?? 0;
    const text = sentence ? this.countSentence(count) : String(count);
    el.text(text);
    if (this._countCycling) {
      gsap.set(el, { width: this.measureCountWidth(text) });
    }
  }

  updateIconCount() {
    this._tourCount = Object.keys(this.model.tourData || {}).length;
    if (this._countTween && this._countTween.isActive()) {
      return;
    }
    this.renderCountLabel(this._countShowsSentence);
  }

  startCountCycle() {
    if (this._countCycling || this._countCyclePlayed) {
      return;
    }
    this._countCycling = true;
    this._countCyclePlayed = true;
    this._countPassesLeft = 3;
    this._countShowsSentence = false;
    const el = this.tourBanner.find('.tour-banner__count');
    const text = String(this._tourCount ?? 0);
    el.text(text);
    gsap.set(el, {
      width: this.measureCountWidth(text),
      autoAlpha: 1,
      overflow: 'hidden',
    });
    this._countDelay = gsap.delayedCall(3, () => this.swapCount(true));
  }

  swapCount(sentence) {
    if (!this._countCycling) {
      return;
    }
    const el = this.tourBanner.find('.tour-banner__count');
    const count = this._tourCount ?? 0;
    const text = sentence ? this.countSentence(count) : String(count);
    const width = this.measureCountWidth(text);
    this._countShowsSentence = sentence;
    this._countTween = gsap.timeline({
      onComplete: () => {
        this._countTween = null;
        if (!this._countCycling) {
          return;
        }
        if (!sentence) {
          this._countPassesLeft -= 1;
          if (this._countPassesLeft <= 0) {
            this._countCycling = false;
            return;
          }
        }
        this._countDelay = gsap.delayedCall(sentence ? 3.5 : 3, () => this.swapCount(!sentence));
      },
    });
    this._countTween
      .to(el, { autoAlpha: 0, duration: 0.22, ease: 'power1.in' })
      .call(() => el.text(text))
      .to(el, { width, duration: 0.4, ease: 'power2.inOut' })
      .to(el, { autoAlpha: 1, duration: 0.25, ease: 'power1.out' }, '<0.12');
  }

  stopCountCycle() {
    this._countCycling = false;
    this._countCyclePlayed = false;
    this._countPassesLeft = 0;
    this._countShowsSentence = false;
    if (this._countDelay) {
      this._countDelay.kill();
      this._countDelay = null;
    }
    if (this._countTween) {
      this._countTween.kill();
      this._countTween = null;
    }
    const el = this.tourBanner.find('.tour-banner__count');
    gsap.killTweensOf(el);
    el.text(String(this._tourCount ?? 0));
    gsap.set(el, { autoAlpha: 1, clearProps: 'width,overflow,visibility,opacity' });
  }

  updateTourItems() {
    this.listContainer.empty();
    const tours = Object.values(this.model.tourData);
    if (Object.keys(tours).length === 0) {
      return;
    }
    tours.forEach(
      (tour) =>
        new TourItem({
          model: this.model,
          container: this.listContainer,
          tour: tour,
          onJoin: () => {
            this.hide();
          },
        })
    );
  }

  hasStartedTours() {
    return this.model.hasStartedTours();
  }

  handleTourIcon() {
    if (this.model.iAmInTour()) {
      this.hide();
      return
    }
    if (this.hasStartedTours()) {
      this.show();
    } else {
      this.hide();
    }
  }
}
